import { Heart, Star, Gift, Smile, Flower2, Music, Coffee, Sparkles } from 'lucide-react';

export const featuredCategories = [
  {
    title: 'Love & Hearts',
    icon: Heart,
    description: 'Express your love with beautiful heart emojis',
    path: '/hearts-1000',
    emoji: '❤️',
    gradient: 'from-pink-500 to-rose-500'
  },
  {
    title: 'Nature & Animals',
    icon: Flower2,
    description: 'Beautiful butterflies and flowers',
    path: '/butterfly-1000',
    emoji: '🦋',
    gradient: 'from-purple-500 to-pink-500'
  },
  {
    title: 'Celebrations',
    icon: Star,
    description: 'Perfect for parties and special occasions',
    path: '/party-1000',
    emoji: '🎉',
    gradient: 'from-indigo-500 to-purple-500'
  },
  {
    title: 'Christmas',
    icon: Gift,
    description: 'Spread holiday cheer with festive emojis',
    path: '/christmas-1000',
    emoji: '🎄',
    gradient: 'from-green-500 to-emerald-500'
  },
  {
    title: 'Expressions',
    icon: Smile,
    description: 'Show your emotions with expressive emojis',
    path: '/kiss-1000',
    emoji: '😊',
    gradient: 'from-amber-500 to-orange-500'
  },
  {
    title: 'Sparkles & Stars',
    icon: Sparkles,
    description: 'Add magic with sparkle emojis',
    path: '/sparkles-1000',
    emoji: '✨',
    gradient: 'from-yellow-500 to-amber-500'
  },
  {
    title: 'Food & Drink',
    icon: Coffee,
    description: 'Delicious food and drink emojis',
    path: '/food-drink',
    emoji: '🍕',
    gradient: 'from-orange-500 to-red-500'
  },
  {
    title: 'Celebrations',
    icon: Music,
    description: 'Party and celebration emojis',
    path: '/celebration-1000',
    emoji: '🎈',
    gradient: 'from-violet-500 to-purple-500'
  }
];